// extracted by mini-css-extract-plugin
export var stepActive = "_2h-3";
export var stepCompleted = "_2h-4";
export var stepConnectorLine = "_2h-b";
export var stepIndicatorCircle = "_2h-6";
export var stepIndicatorCircleCompleted = "_2h-7";
export var stepIndicatorCircleDefault = "_2h-8";
export var stepIndicatorTextCompleted = "_2h-9";
export var stepIndicatorTextDefault = "_2h-a";
export var stepPending = "_2h-5";
export var wizardContainer = "_2h-1";
export var wizardContent = "_2h-2";
export var wizardModal = "_2h-0";